<template>
  <div>
    <v-card class="box">
      <v-row fluid justify="center">
        <v-radio-group v-model="print_type" row>
          <!-- <v-radio label="Print Single" value="Single"></v-radio> -->
          <v-radio label="Print Bulk Icards" value="Bulk"></v-radio>
          <v-radio label="Print Specific Icards" value="Specific"></v-radio>
        </v-radio-group>
      </v-row>
      <template v-if="print_type == 'Bulk'">
        <v-row dense justify="center">
          <v-col sm="3" md="3">
            <v-autocomplete class="no-display" :items="academic_year_list" item-value="ay_id" item-text="academicyear"
              v-model="ay" label="Select Ay" dense rounded outlined color="#0F2027"></v-autocomplete>
          </v-col>
          <v-col sm="3" md="3">
            <v-autocomplete class="no-display" :items="std_list" item-value="id" item-text="standard" v-model="std"
              label="Search Standard" dense rounded outlined color="#0F2027"></v-autocomplete>
          </v-col>
          <v-col sm="3" md="3">
            <v-autocomplete class="no-display" :items="div_list" item-value="id" item-text="division" v-model="div"
              label="Search Division" dense rounded outlined color="#0F2027"></v-autocomplete>
          </v-col>
          <v-col sm="3" md="3">
            <v-autocomplete color="#0F2027" dense rounded required v-model="status" :items="status_list"
              item-text="name" item-value="id" label="Status" outlined persistent-hint hint="Select Status" />
          </v-col>
        </v-row>
        <v-row v-if="std && div && status" dense justify="center">
          <v-col sm="3" md="3">
            <v-btn color="primary" @click="bulk">Proceed to <span class="i-card">bulk</span> student icard print</v-btn>
          </v-col>
        </v-row>
      </template>
      <template v-if="print_type == 'Specific'">
        <br />
        <v-row justify="center" dense>
          <v-col sm="5">
            <v-textarea v-model="prn" color="#0F2027" rounded dense label="Enter Comma Seperated PRN"
              outlined></v-textarea>
          </v-col>
        </v-row>
        <v-row justify="center" dense>
          <v-col sm="3" v-if="prn">
            <v-btn color="primary" @click="getStudentIcardSpecificPRN()">Proceed To <span class="i-card">
                Student</span>Icard print</v-btn>
          </v-col>
        </v-row>
      </template>
    </v-card>
  </div>
</template>
<script>
import axios from "axios";
import QrcodeVue from "qrcode.vue";
import VueBarcode from "vue-barcode";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  components: {
    barcode: VueBarcode,
    QrcodeVue,
  },
  data: () => ({
    comp_load: false,
    stud_list: null,
    radios: null,
    radios1: null,
    stud_data: null,
    child_data: null,
    icard_data: [],
    print_type: null,
    std_list: null,
    div_list: null,
    std: null,
    div: null,
    org_id: null,
    status_list: [
      { name: "Active", id: "0" },
      { name: "Temporary Inactive", id: "1" },
      { name: "Permanent Inactive", id: "2" },
    ],
    status: null,
    active_status: null,
    academic_year_list: [],
    ay: "",
    prn: null,
  }),
  mounted() {
    this.onload();
    this.org_id = localStorage.getItem("EPS-org-id");
  },
  methods: {
    bulk() {
      localStorage.setItem("icard_ay_id", this.ay);
      localStorage.setItem("icard_std_id", this.std);
      localStorage.setItem("icard_div_id", this.div);
      localStorage.setItem("icard_learner_status", this.status);
      let routeData = this.$router.resolve({
        name: "sanjivani-student-bulk-card-print",
      });
      window.open(routeData.href, "_blank");
    },
    getStudentIcardSpecificPRN() {
      localStorage.setItem("prn", JSON.stringify(this.prn));
      let routeData = this.$router.resolve({
        name: "sanjivani-specific-icard-print",
      });
      window.open(routeData.href, "_blank");
    },
    print() {
      this.$store.state.drawer = false;
      let that = this;
      window.onafterprint = function () {
        that.$store.state.drawer = true;
      };
      setTimeout(function () {
        window.print();
      }, 100);
    },
    onload() {
      this.comp_load = true;
      axios
        .post("/admission/getAllStudents1")
        .then((res) => {
          if (res.data.msg == "200") {
            this.stud_list = res.data.stud_list;
            this.std_list = res.data.std_list;
            this.div_list = res.data.div_list;
            this.academic_year_list = res.data.academic_year_list;
            this.ay = res.data.current_ay;
          } else {
            alert("Somthing went wrong!!!");
          }
        })
        .catch((error) => {
          alert("Somthing went wrong!!!");
        })
        .finally(() => {
          this.comp_load = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
};
</script>
<style scoped>
@font-face {
  font-family: "GregorianFLF";
  src: url("https://db.onlinewebfonts.com/t/39b0c3d169333ae5bb25727bfdbad96d.eot");
  src: url("https://db.onlinewebfonts.com/t/39b0c3d169333ae5bb25727bfdbad96d.eot?#iefix")format("embedded-opentype"),
    url("https://db.onlinewebfonts.com/t/39b0c3d169333ae5bb25727bfdbad96d.woff2")format("woff2"),
    url("https://db.onlinewebfonts.com/t/39b0c3d169333ae5bb25727bfdbad96d.woff")format("woff"),
    url("https://db.onlinewebfonts.com/t/39b0c3d169333ae5bb25727bfdbad96d.ttf")format("truetype"),
    url("https://db.onlinewebfonts.com/t/39b0c3d169333ae5bb25727bfdbad96d.svg#GregorianFLF")format("svg");
}

@media print {

  header,
  footer,
  nav,
  date {
    display: none !important;
  }

  .no-display,
  .v-input__control,
  input[type="button"],
  input[type="submit"],
  input[type="reset"],
  #v-card {
    display: none !important;
    font-size: xx-large !important;
  }

  v-card {
    border: none !important;
  }

  * {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .pagebreak {
    page-break-before: always !important;
  }

  @page {
    size: A4;
    margin-top: none;
    padding-top: none;
    size: 10.5in 9.5in;
    /* size: 88mm 86.614mm; */
  }
}

.box1 {
  border: 2px solid black;
}

.i-card {
  color: greenyellow;
  font-size: medium;
  margin-left: 2px;
  margin-right: 2px;
}
</style>
